// LQIP (Low Quality Image Placeholder) blur-up effect
function setupLQIPImage(img) {
  if (!img || !img.getAttribute('data-lqip') || img.classList.contains('loaded')) return;

  const lqipSrc = img.getAttribute('data-lqip');
  const container = img.closest('.media-container') || img.parentElement;

  if (lqipSrc && container) {
    const lqipImg = new Image();
    lqipImg.src = lqipSrc;
    container.style.backgroundImage = 'url(' + lqipSrc + ')';
    container.style.backgroundSize = 'cover';
    container.style.backgroundPosition = 'center';
    container.style.backgroundRepeat = 'no-repeat';
  }

  function handleImageLoad() {
    img.classList.add('loaded');
    if (container && container.style.backgroundImage) {
      container.style.backgroundImage = '';
    }
  }

  if (img.complete && img.naturalWidth > 0) {
    handleImageLoad();
  } else {
    img.addEventListener('load', handleImageLoad, { once: true });
    img.addEventListener('error', handleImageLoad, { once: true });
    setTimeout(function () {
      if (!img.classList.contains('loaded')) handleImageLoad();
    }, 3000);
  }
}

function shouldSkipAutoplayAttempt(video) {
  if (!video) return true;
  if (video.dataset.autoplayHandled === 'true') return true;
  if (video.getAttribute('data-autoplay-managed') !== 'true') return true;
  const style = window.getComputedStyle(video);
  return style.display === 'none' || style.visibility === 'hidden';
}

function enableVideoFallback(video) {
  if (!video || video.dataset.autoplayHandled === 'true') return;
  video.dataset.autoplayHandled = 'true';
  video.removeAttribute('autoplay');
  video.autoplay = false;
  video.controls = false;
  video.removeAttribute('controls');
  video.pause();
  try {
    video.currentTime = 0;
  } catch (e) {
    // Ignore if currentTime cannot be set yet.
  }
}

function attemptManagedAutoplay(video) {
  video.controls = false;
  video.removeAttribute('controls');
  video.muted = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');

  const playPromise = video.play();
  if (playPromise && typeof playPromise.then === 'function') {
    playPromise.then(function () {
      video.dataset.autoplayHandled = 'true';
    }).catch(function () {
      enableVideoFallback(video);
    });
    return;
  }

  if (video.paused) {
    enableVideoFallback(video);
  } else {
    video.dataset.autoplayHandled = 'true';
  }
}

function setupAutoplayVideo(video) {
  if (shouldSkipAutoplayAttempt(video)) return;

  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const saveDataEnabled = !!(connection && connection.saveData);

  if (prefersReducedMotion || saveDataEnabled) {
    enableVideoFallback(video);
    return;
  }

  attemptManagedAutoplay(video);
}

function setupImageFallback(img) {
  if (!img || !img.getAttribute('data-fallback-src')) return;
  const fallbackSrc = img.getAttribute('data-fallback-src');
  img.addEventListener('error', function () {
    if (this.src !== fallbackSrc) this.src = fallbackSrc;
  }, { once: true });
}

function initMediaEnhancements() {
  document.querySelectorAll('.media-lqip[data-lqip]').forEach(setupLQIPImage);
  document.querySelectorAll('video[data-autoplay-managed="true"]').forEach(setupAutoplayVideo);
  document.querySelectorAll('.media[data-fallback-src]').forEach(setupImageFallback);

  const observerRoot = document.querySelector('main') || document.body;
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        const el = node;

        if (el.classList && el.classList.contains('media-lqip') && el.getAttribute('data-lqip')) {
          setupLQIPImage(el);
        }
        const lqipImages = el.querySelectorAll && el.querySelectorAll('.media-lqip[data-lqip]');
        if (lqipImages) {
          for (let i = 0; i < lqipImages.length; i++) setupLQIPImage(lqipImages[i]);
        }

        if (el.classList && el.classList.contains('media') && el.getAttribute('data-fallback-src')) {
          setupImageFallback(el);
        }
        const fallbackImages = el.querySelectorAll && el.querySelectorAll('.media[data-fallback-src]');
        if (fallbackImages) {
          for (let j = 0; j < fallbackImages.length; j++) setupImageFallback(fallbackImages[j]);
        }

        if (el.tagName === 'VIDEO' && el.getAttribute('data-autoplay-managed') === 'true') {
          setupAutoplayVideo(el);
        }
        const autoplayVideos = el.querySelectorAll && el.querySelectorAll('video[data-autoplay-managed="true"]');
        if (autoplayVideos) {
          for (let k = 0; k < autoplayVideos.length; k++) setupAutoplayVideo(autoplayVideos[k]);
        }
      });
    });
  });
  observer.observe(observerRoot, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMediaEnhancements, { once: true });
} else {
  initMediaEnhancements();
}
